@if (loadingData()) {
	<div class="mt-4">
		<mat-progress-bar mode="indeterminate" value="50"></mat-progress-bar>
	</div>
} @else {
	<app-bag-transport-term-change-max-rooms
		[termId]="termId()"
		[maxRoomsValue]="maxRooms()"
		(refreshRooms)="refreshRooms()"
		(refreshMaxRooms)="refreshMaxRooms()"
	></app-bag-transport-term-change-max-rooms>

	<app-bag-transport-term-general-rooms-data
		[sumOfConfirmedOffers]="generalRoomsData()?.sumOfConfirmedOffers"
		[sumOfOptionOffers]="generalRoomsData()?.sumOfOptionOffers"
		[sumOfAllReservations]="generalRoomsData()?.sumOfAllReservations"
		[maxRooms]="maxRooms()"
	></app-bag-transport-term-general-rooms-data>

	<app-bag-transport-term-room-availabilities
		[rooms]="rooms()"
		[termId]="termId()"
		(roomAvailabilityChanged)="changeRoomAvailability($event)"
		(roomAvailabilityCanceled)="cancelRoomAvailability()"
		(roomAvailabilityEdit)="editRoomAvailability($event)"
	></app-bag-transport-term-room-availabilities>
}
